export const listByIdNameSpeciesCropSector = [
    {ID: 'All', NAME: 'All'},
    {ID: 'agricultural', NAME: 'Agricultural'},
    {ID: 'vegetable', NAME: 'Vegetable'},
    {ID: 'fruit', NAME: 'Fruit'},
    {ID: 'ornamental', NAME: 'Ornamental'},
    {ID: 'forest', NAME: 'Forest'},
    {ID: 'miscellaneous', NAME: 'Miscellaneous'},
];
